import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Entity, RoleEntityPermissionMap } from 'ag-common-lib/public-api';
import { hasPermissionGuard } from 'ag-common-svc/shared/utils/has-permission-guard';
import { ARMAuthService } from 'src/app/shared/services/util/arm-auth.service';
import { AppRoutes } from 'src/app/app.model';

/**
 * Guards both Agent Registry screens — the Agent IDs grid and Downline Files.
 *
 * They used to sit under `carriers-production-reporting`, whose guard asks for
 * `reportsGenerationPipeline`. That is the wrong question for these two: the menu
 * shows them on `agentRegistry` and the API gates them on `agentRegistry`, which is
 * a top-level entity granted on its own (`parentId: null`). So anyone holding the
 * Agent Registry role but not the import pipeline saw the menu items and was bounced
 * to Access Denied by the section guard. They are their own routes now, asking the
 * same question the menu and the API already ask.
 */
@Injectable({ providedIn: 'root' })
export class AgentRegistryGuard implements CanActivate {
  constructor(
    private authService: ARMAuthService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.armPermissions$.pipe(
      map((roleEntityPermissionMap: RoleEntityPermissionMap) => {
        return hasPermissionGuard([Entity.agentRegistry], roleEntityPermissionMap);
      }),
      tap(hasPermission => {
        if (!hasPermission) {
          this.router.navigate(['/', AppRoutes.AccessDenied]);
        }
      }),
    );
  }
}
